import { UNCALIBRATED_WALL_STROKE_PT, WALL_THICKNESS_M } from "../constants";
import type { GetWallStrokeWidthPt } from "./types";

export const getWallStrokeWidthPt: GetWallStrokeWidthPt = ({
  metersPerPdfPoint,
}) =>
  metersPerPdfPoint > 0
    ? WALL_THICKNESS_M / metersPerPdfPoint
    : UNCALIBRATED_WALL_STROKE_PT;
